import { BOGUS_DATA_ATTR } from '../utils/dom';
export const INLINE_TARGET_FORMAT = 'hsInlineTarget';
export const INLINE_TARGET_ATTR = 'data-mce-inline-target';
export const INLINE_TARGET_ATTR_RNG = 'data-mce-inline-target-range';
export const INLINE_TARGET_FORMAT_CONFIG = {
  inline: 'span',
  attributes: {
    [BOGUS_DATA_ATTR]: '1',
    [INLINE_TARGET_ATTR]: 'true',
    [INLINE_TARGET_ATTR_RNG]: 'true'
  },
  remove: 'empty'
};